import React from 'react';
import { createRoot } from 'react-dom/client';
import "./styles/index.scss";
import Routes from './routes';
import registerServiceWorker  from "./registerServiceWorker";
import { Provider } from "react-redux"
import store from "./store"

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure({
    limit: 1,
    newestOnTop: true
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Provider store={store}><Routes /></Provider>);

registerServiceWorker();